import moment from 'moment/moment';
import { dateFormat } from '../constants';

export const checkIfWithin24Hours = (
  originalAppointmentDate,
  originalAppointmentTime
) => {
  if (!originalAppointmentDate || !originalAppointmentTime) return false;

  const originalAppointmentDateTime = moment(
    `${originalAppointmentDate} ${originalAppointmentTime}`,
    `${dateFormat} HH:mm`
  );

  if (!originalAppointmentDateTime.isValid()) return false;

  const hoursDifference = originalAppointmentDateTime.diff(
    moment(),
    'hours',
    true
  );

  const isWithin24Hours = hoursDifference <= 24 && hoursDifference >= 0;

  return isWithin24Hours;
};
